import React from "react";
import PropTypes from "prop-types";
import { Title, Text, Button } from "../../ui";
import { Flex } from "../../layout";
import "./Header.css";

const Header = ({
  children,
  title,
  text,
  size = "sm",
  level = "h3",
  onClick,
  to,
  textButton,
  iconRight,
  iconLeft,
  childrenButton,
}) => {
  return (
    <Flex type="between-center" className="Header" gap={10} wrap>
      <Flex type="col-center" className="content" gap={50}>
        {(title || (children && text)) && (
          <Title level={level}>{title || children}</Title>
        )}
        {(text || (children && title)) && (
          <Text size={size}>{text || children}</Text>
        )}
      </Flex>
      {textButton && (
        <Button
          text={textButton}
          onClick={onClick}
          iconRight={iconRight}
          iconRIght={iconLeft}
          to={to}
          className="buttonHeader"
        >
          {childrenButton}
        </Button>
      )}
    </Flex>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  textButton: PropTypes.string,
  iconRight: PropTypes.node,
  iconLeft: PropTypes.node,
  childrenButton: PropTypes.node,
};

export default Header;
